"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutItemFacade = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
var sdk_model_1 = require("@gooddata/sdk-model");
/**
 * @alpha
 */
var DashboardLayoutItemFacade = /** @class */ (function () {
    function DashboardLayoutItemFacade(sectionFacade, item, itemIndex) {
        this.sectionFacade = sectionFacade;
        this.item = item;
        this.itemIndex = itemIndex;
    }
    DashboardLayoutItemFacade.for = function (sectionFacade, item, index) {
        return new DashboardLayoutItemFacade(sectionFacade, item, index);
    };
    DashboardLayoutItemFacade.prototype.raw = function () {
        return this.item;
    };
    DashboardLayoutItemFacade.prototype.section = function () {
        return this.sectionFacade;
    };
    DashboardLayoutItemFacade.prototype.index = function () {
        return this.itemIndex;
    };
    DashboardLayoutItemFacade.prototype.indexIs = function (index) {
        return this.index() === index;
    };
    DashboardLayoutItemFacade.prototype.isFirst = function () {
        return this.indexIs(0);
    };
    DashboardLayoutItemFacade.prototype.isLast = function () {
        return this.indexIs(this.sectionFacade.items().count() - 1);
    };
    DashboardLayoutItemFacade.prototype.widget = function () {
        return this.item.widget;
    };
    DashboardLayoutItemFacade.prototype.widgetEquals = function (widget) {
        return isEqual_1.default(this.widget(), widget);
    };
    DashboardLayoutItemFacade.prototype.widgetIs = function (widget) {
        return this.widget() === widget;
    };
    DashboardLayoutItemFacade.prototype.isEmpty = function () {
        return isNil_1.default(this.widget());
    };
    DashboardLayoutItemFacade.prototype.size = function () {
        return this.item.size;
    };
    DashboardLayoutItemFacade.prototype.sizeForScreen = function (screen) {
        return this.size()[screen];
    };
    DashboardLayoutItemFacade.prototype.hasSizeForScreen = function (screen) {
        return !isNil_1.default(this.sizeForScreen(screen));
    };
    DashboardLayoutItemFacade.prototype.testRaw = function (pred) {
        return pred(this.raw());
    };
    DashboardLayoutItemFacade.prototype.test = function (pred) {
        return pred(this);
    };
    DashboardLayoutItemFacade.prototype.isWidgetItem = function () {
        return sdk_backend_spi_1.isWidget(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isWidgetDefinitionItem = function () {
        return sdk_backend_spi_1.isWidgetDefinition(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isKpiWidgetItem = function () {
        return sdk_backend_spi_1.isKpiWidget(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isKpiWidgetDefinitionItem = function () {
        return sdk_backend_spi_1.isKpiWidgetDefinition(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isInsightWidgetItem = function () {
        return sdk_backend_spi_1.isInsightWidget(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isInsightWidgetDefinitionItem = function () {
        return sdk_backend_spi_1.isInsightWidgetDefinition(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isLayoutItem = function () {
        return sdk_backend_spi_1.isDashboardLayout(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isCustomItem = function () {
        return !sdk_backend_spi_1.isDashboardLayoutItem(this.widget());
    };
    DashboardLayoutItemFacade.prototype.isWidgetItemWithRef = function (ref) {
        if (this.isWidgetItem()) {
            return sdk_model_1.areObjRefsEqual(this.item.widget.ref, ref);
        }
        return false;
    };
    DashboardLayoutItemFacade.prototype.isWidgetItemWithInsightRef = function (ref) {
        if (this.isInsightWidgetItem() || this.isInsightWidgetDefinitionItem()) {
            return sdk_model_1.areObjRefsEqual(this.item.widget.insight, ref);
        }
        return false;
    };
    DashboardLayoutItemFacade.prototype.isWidgetItemWithKpiRef = function (ref) {
        if (this.isKpiWidgetItem() || this.isKpiWidgetDefinitionItem()) {
            return sdk_model_1.areObjRefsEqual(this.item.widget.ref, ref);
        }
        return false;
    };
    return DashboardLayoutItemFacade;
}());
exports.DashboardLayoutItemFacade = DashboardLayoutItemFacade;
//# sourceMappingURL=item.js.map